<template>
  <img
    height="40"
    width="40"
    src="/logo-sdaemon.png"
    alt="Sdaemon"
    style="object-fit: contain"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
